import React, { useEffect, useState, useRef } from 'react';

import { DataGrid } from '@mui/x-data-grid';
import { debounce, isEmpty, isEqual } from 'lodash';
import PropTypes from 'prop-types';

import { CustomPagination } from 'common/components';
import { DEBOUNCE_TIME_500, TABLE_PAGE_SIZE_OPTIONS } from 'common/constants';

import BulkOperationsCard from './BulkOperationsCard';
import ProductColumns from './ProductColumns';

const ListItems = ({
    filterData,
    filterItems,
    handleClickAdd,
    isFetching,
    items,
    paginationData,
    panelsIdsData,
    productBrands,
    setFilterData,
}) => {
    const [currentFilterData, setCurrentFilterData] = useState(filterData);
    const [rowCount, setRowCount] = useState(paginationData?.rowCount || 0);

    const handleOnFilter = useRef(
        debounce((filter) => filterItems(filter), DEBOUNCE_TIME_500),
    ).current;

    const pageSizeOptions = TABLE_PAGE_SIZE_OPTIONS;

    const columns = ProductColumns({ handleClickAdd, panelsIdsData });
    const getRowHeight = () => 'auto';
    const initialState = {
        pagination: { paginationModel: { pageSize: pageSizeOptions[0] } },
    };
    const onPaginationModelChange = (model) =>
        setFilterData((prev) => ({ ...prev, ...model }));
    const onSortModelChange = (model) => {
        if (!model[0]) return;
        setFilterData((prev) => ({
            ...prev,
            orderBy: model[0].field.toLocaleLowerCase(),
            sortBy: model[0].sort,
        }));
    };
    const paginationModel = {
        page: paginationData?.current_page - 1 || 0,
        pageSize: filterData?.pageSize || pageSizeOptions[0],
    };
    const slots = { pagination: CustomPagination };
    const slotProps = { pagination: { pageSizeOptions } };

    useEffect(() => {
        if (isEmpty(paginationData)) return;
        setRowCount((prev) =>
            paginationData?.total_rows !== undefined
                ? paginationData?.total_rows
                : prev,
        );
    }, [paginationData?.total_rows]);

    useEffect(() => {
        if (isEqual(currentFilterData, filterData)) return;
        handleOnFilter(filterData);
        setCurrentFilterData(filterData);
    }, [filterData]);

    return (
        <>
            <BulkOperationsCard
                filterData={filterData}
                productBrands={productBrands}
                setFilterData={setFilterData}
            />

            <DataGrid
                columns={columns}
                disableColumnMenu
                disableRowSelectionOnClick
                getRowHeight={getRowHeight}
                hideFooterSelectedRowCount
                initialState={initialState}
                loading={isFetching}
                onPaginationModelChange={onPaginationModelChange}
                onSortModelChange={onSortModelChange}
                pageSizeOptions={pageSizeOptions}
                pagination
                paginationMode="server"
                paginationModel={paginationModel}
                rowCount={rowCount}
                rows={items}
                slotProps={slotProps}
                slots={slots}
                sortingMode="server"
            />
        </>
    );
};

ListItems.propTypes = {
    filterData: PropTypes.object,
    filterItems: PropTypes.func,
    handleClickAdd: PropTypes.func,
    isFetching: PropTypes.bool,
    items: PropTypes.array,
    paginationData: PropTypes.object,
    panelsIdsData: PropTypes.array,
    productBrands: PropTypes.array,
    setFilterData: PropTypes.func,
};

export default ListItems;
